module.exports = __webpack_public_path__ + "media/images/covid/icons/gargleS-3a80725f9e63dfbcfcc0725c0ed2b7b0.png";